import { PartialType, PickType } from '@nestjs/swagger';
import { JobRepairPhotoDto } from './job-repair-photo.dto';
import { JobRepairPhotoUpdatableInterface } from '../interfaces/job-repair-photo-updatable.interface';

export class JobRepairPhotoUpdateDto
  extends PartialType(
    PickType(JobRepairPhotoDto, ['fileName', 'metaData', 'repairPhotoType']),
  )
  implements JobRepairPhotoUpdatableInterface {}
